export const TranslationsID = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: 'Pesan Secara Online',
        cart: 'Keranjang',
        open_24: '24 Jam',
        closed: 'Tidak Buka',
        free: 'GRATIS',
        something_went_wrong: 'Terjadi kesalahan',
        try_again: 'coba lagi',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Senin',
                tuesday: 'Selasa',
                wednesday: 'Rabu',
                thursday: 'Kamis',
                friday: 'Jumat',
                saturday: 'Sabtu',
                sunday: 'Minggu',
            },
        },
        services: {
            pickup: 'Diambil',
            delivery: 'Dikirim',
            dine_in: 'Makan-Di-Tempat',
            table_booking: 'Pesan Meja',
        },
        payment: {
            method: {
                cash: 'Tunai',
                card: 'Kartu',
                stripe: 'Kartu Kredit',
                paypal: 'PayPal',
                cardconnect: 'Kartu Kredit',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                custom: 'Kustom',
            },
            backend_method: {
                cash: 'Tunai',
                card: 'Kartu',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                custom: 'Kustom',
            },
            status: {
                success: 'Berhasil',
                pending: 'Sedang Menunggu',
                error: 'Kesalahan',
                refunded: 'Pengembalian Uang',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Menghapus',
                drop_here: 'Masukkan file Anda di sini atau klik untuk memilih salah satu',
                accepts: 'Menerima file {{fileTypes}}',
                errors: {
                    max_files: 'Maksimal {{number}} yang diizinkan',
                    max_size: 'Maksimal ukuran file {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "Toko saat ini sedang tutup dan untuk makan di tempat saat ini juga tidak dapat dilakukan. Anda dapat mencoba memesan sekarang untuk tanggal dan waktu nanti.",
            },
            buttons: {
                order: {
                    book_order: "Buat Reservasi / Pesan Online",
                    order_online: "Pesan Online",
                    book_table: "Buat Reservasi",
                    order: "Pesanan",
                    book: "Pesan Tempat",
                    cart: "Keranjang",
                    restart: "Mulai lagi dari awal",
                    closed: "Toko Tutup",
                    not_accepting: "Tidak Menerima Pesan",
                },
            },
        },
        modals: {
            auth: {
                login: "Masuk",
                register: "Daftar",
                register_commence: "Lanjut",
                register_complete: "Buat Akun",
                register_confirmation_sent: "Kode konfirmasi telah dikirim ke email Anda. Siliahkan massukan kode konfirmasi dibawah ini",
                register_confirmation_resent: "Kode konfirmasi telah dikirim lagi, periksa spam Anda atau mulai ulang prosesnya",
                register_restart: "Mulai lagi",
                register_resend_code: "Kirim ulang kode",
                login_placeholder: "E-mail",
                password_placeholder: "Kata Sandi",
                confirm_password_placeholder: "Konfirmasi Kata Sandi",
                confirmation_code_placeholder: "Kode Konfirmasi Email",
                accept_terms: "Terima Syarat & Ketentuan",
                accept_terms_view: "Melihat",
                login_facebook: "Anda Berhasil Masuk dengan Facebook",
                login_google: "Anda Berhasil Masuk dengan Google",
                benefits: "Masuk atau buat akun untuk menyimpan semua pesanan Anda",
                logged_in: "Anda Berhasil Masuk",
                logged_out: "Anda Telah Keluar",
                password_reset: {
                    init_button: "Kirim email pengaturan ulang kata sandi",
                    init_success: "Tautan pengaturan ulang kata sandi telah dikirim ke email Anda",
                    complete_button: "Merubah Kata Sandi",
                    complete_success: "Kata sandi berhasil disetel ulang, masuk dengan kata sandi baru Anda",
                    forgot_password_text: "Lupa Kata Sandi? ",
                    forgot_password_link: "Setel Ulang Kata Sandi",
                    remember_password_text: "Ingat kata sandi Anda? ",
                    remember_password_link: "Kembali",
                    invalid_title: "Setel Ulang Kata Sandi Tidak Valid",
                    invalid_description: "Tautan pengaturan ulang kata sandi ini tidak valid, minta yang baru sebagai gantinya",
                    invalid_link: "Pergi ke Login",
                    title: "Merubah Kata Sandi",
                    description: "Masukan kata sandi baru untuk akun anda",
                },
                error_generic: "Terjadi kesalahan, silahkan coba lagi atau hubungi kami",
                error_accept_terms: "Terima Syarat & Ketentuan",
                error_password_length: "Minimal 6 karakter untuk kata sandi",
                error_social: "Terjadi kesalahan, silahkan coba lagi atau hubungi kami",
                error_confirmation_code: "Kode konfirmasi tidak valid",
                error_invalid_code: "Kode konfirmasi tidak valid",
                error_exists: "Pengguna ini sudah ada",
                error_invalid_email_pass: "Alamat email tau kata sandi tidak valid",
                error_password_no_match: "Pastikan kata sandi Anda cocok",
                error_user_not_found: "Pengguna dengan alamat email yang sama tidak ada",
                error_invalid_email: "Alamat email tidak valid",
                error_invalid_reset_token: "Tautan setel ulang tidak valid, minta yang lain",
            },
            booking: {
                form: {
                    name: "Nama Lengkap",
                    email: "Alamat E-Mail",
                    phone: "Nomor Telepon",
                    number_of_people: "Berapa Orang",
                    number_of_people_max: "Jumlah Orang ({{max_people}} Max)",
                    number_of_people_min: "Jumlah Orang ({{min_people}} Min)",
                    number_of_people_max_min: "Jumlah Orang (antara {{min_people}} ke {{max_people}})",
                    notes: "Catatan / Permintaan Khusus",
                    submit: "Kirimkan Permintaan Reservasi",
                    email_optional: "(opsional)",
                    date: "Tanggal",
                    duration: "Durasi",
                    seating: "Waktu tersedia",
                    number_of_guests: "Jumlah tamu",
                    notes_placeholder: "Alergi, acara, preferensi tempat duduk",
                    reserving: "Memesan...",
                    reserve_table: "Pesan meja",
                    please_choose_a_date_and_time: "Pilih tanggal dan waktu.",
                    invalid_people: "Jumlah orang harus antara {{min}} dan {{max}}.",
                    party_size_max_fallback: "maksimum yang diizinkan",
                    loading_available_times: "Memuat waktu yang tersedia…",
                    select_a_date_to_see_available_times: "Pilih tanggal untuk melihat waktu yang tersedia.",
                    no_times_available_for_this_date: "Tidak ada waktu tersedia untuk tanggal ini. Pilih hari lain.",
                    shift: "Shift",
                    service_times: "Jam layanan",
                    new_shift: "Shift baru",
                    time: "waktu",
                    times: "waktu",
                    unavailable: "Tidak tersedia",
                    available: "Tersedia",
                    required_name: "Masukkan nama Anda.",
                    required_phone: "Masukkan nomor telepon Anda.",
                    required_email: "Masukkan email Anda.",
                    invalid_email: "Masukkan email yang valid.",
                    required_terms: "Terima syarat sebelum memesan.",
                    missing_custom_fields: "Jawablah semua pertanyaan wajib.",
                    reservation_is_unavailable: "Reservasi tidak tersedia.",
                    please_contact_the_restaurant_directly: "Hubungi restoran secara langsung.",
                    almost_done: "Hampir selesai",
                    your_details: "Data Anda",
                    tell_us_who_s_coming: "Beritahu kami siapa yang datang agar kami dapat mengonfirmasi reservasi Anda.",
                    book_your_table: "Pesan meja Anda",
                    choose_a_time_that_works_for_you: "Pilih waktu yang cocok untuk Anda.",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "Kirim permintaan reservasi dan restoran akan mengurus sisanya.",
                    select_date: "Pilih tanggal",
                    standard: "Standar",
                    minutes: "menit",
                    next: "Berikutnya →",
                    back: "← Kembali",
                    accept_terms: "Saya menerima syarat dan ketentuan.",
                    info_1: "Anda akan menerima email pemberitahuan ketika reservasi Anda diterima atau ditolak",
                },
                errors: {
                    not_found: "Pemesanan tidak ada. Itu mungkin dihapus",
                    generic: "Terjadi kesalahan, segarkan halaman atau hubungi kami",
                    something_went_wrong: "Terjadi kesalahan",
                    accept_terms: "Silahkan, terima Syarat & Ketentuan",
                    required_phone: "Silahkan masukkan nomor telepon Anda",
                    required_email: "Silahkan masukkan email Anda",
                    required_name: "Silahkan masukkan nama Anda",
                    invalid_email: "Silakan masukkan alamat email yang valid",
                    invalid_phone: "Silahkan masukkan nomor telepon yang valid",
                    invalid_people: "Jumlah orang tidak valid",
                    booking_capacity_threshold: "Kami penuh untuk waktu ini. Coba waktu lain.",
                    slot_unavailable: "Kami penuh untuk jumlah orang ini. Coba waktu lain.",
                    booking_date_paused: "Reservasi dijeda untuk tanggal ini. Pilih hari lain.",
                    invalid_table_assignment: "Meja tersebut tidak muat untuk rombongan Anda. Pilih waktu lain.",
                    exceeded_order_limit: "Terlalu banyak permintaan reservasi. Coba lagi nanti.",
                    validation_failed_recaptcha_v3: "Terdeteksi lalu lintas tidak biasa. Apakah Anda menggunakan VPN? Selesaikan verifikasi di atas dan coba lagi.",
                    validation_failed_recaptcha_v2: "Reservasi tidak dapat dimulai. Coba lagi atau gunakan cara lain. Jika Anda menggunakan VPN, coba matikan terlebih dahulu.",
                    booking_already_exists: "Reservasi ini sudah dikirim. Periksa email Anda atau buka tautan reservasi.",
                    invalid_party_size: "Pilih jumlah orang yang valid.",
                    invalid_request: "Permintaan tidak valid. Segarkan halaman dan coba lagi.",
                    table_booking_unavailable: "Pemesanan meja tidak tersedia.",
                },
            },
            cart: {
                title: "Keranjang",
                proceed_to_checkout: "Lanjutkan untuk Checkout",
                edit_dish: "Ubah",
                remove_dish: "Hapus",
                no_items_1: "Keranjang Anda kosong",
                no_items_2: "Anda harus belanja duluh",
                free_delivery_notice: "Pengiriman gratis untuk pesanan di atas {{value, currency}}",
                errors: {
                    min_order_promo: "Nilai belanja minimum {{value, currency}} sebelum promo ini berlaku",
                    min_order_delivery: "Nilai belanja minimum {{value, currency}} untuk delivery",
                },
                promo: {
                    heading: "Kode Promo",
                    placeholder: "Enter kode promo Anda",
                    add: "Tambahkan Kode",
                    title: "Promo {{name}} ditambahkan ke keranjang",
                    fixed_discount: "Diskon {{value, currency}}",
                    percent_discount: "Diskon {{value}}%",
                    added_to_cart: "Promo {{name}} ditambahkan ke keranjang",
                    errors: {
                        not_found: "Promo tidak ditemukan",
                        disabled: "Promo dinonaktifkan",
                        not_available: "Promo saat ini tidak tersedia",
                        logged_in_only: "Anda harus masuk untuk menggunakan promo ini",
                        already_used: "Anda sudah menggunakan promo ini",
                        invalid: "Promo ini tidak berlaku lagi",
                        invalid_service: "Promo ini tidak berlaku untuk layanan yang Anda pilih",
                        later_only: "Hanya berlaku untuk pre-order",
                        now_only: "Berlaku hanya untuk pesanan saat ini juga, bukan untuk pre-order",
                        generic: "Ups… terjadi kesalahan dan telah dicatat",
                        dishes_required_multi: "Promo ini hanya akan berlaku jika hidangan tertentu ditambahkan ke keranjang Anda",
                        dishes_required_single: "Promo ini berlaku hanya untuk '{{dish}}'",
                    },
                },
                tip: {
                    title: "Tip Persenan",
                    placeholder: "Tambah tip persenan",
                },
            },
            checkout: {
                title: "Checkout",
                subtitle: "Konfirmasikan detail pesanan Anda",
                details: {
                    service: "Layanan",
                    due: "Jatuh tempo",
                    due_now_asap: "Sekarang / Secepatnya",
                    address: "Alamat Pengiriman",
                    total: "Total",
                    table: "Meja",
                    store_location: "Alamat Toko",
                },
                customer: {
                    title: "Pelanggan",
                    subtitle: "Masuk untuk menyimpan pesanan & detail Anda",
                    button: "Masuk",
                    name: "Nama Lengkap",
                    email: "Alamat E-Mail",
                    phone: "Nomor Telepon",
                    phone_important: "Nomor Telepon (Important)",
                    notes: "Catatan untuk Pesanan",
                    delivery_notes: "Petunjuk untuk Pengiriman / Catatan untuk Pesanan",
                    optional: "Boleh Memilih"
                },
                payment: {
                    title: "Cara Pembayaran",
                },
                accept_terms: "Terima Syarat & Ketentuan",
                accept_terms_view: "Lihat",
                processing_order: "Sedang Memproses Pesanan",
                warning: {
                    different_payment_currency: "Harga toko dalam {{store_currency}} tetapi cara pembayaran dalam {{payment_currency}}",
                    closing_soon: "Akan segera tutup, pesanan harus dilakukan dalam {{value}} menit",
                    closed: "Maaf, layanan ini telah tutup dan tidak bisa menerima pesanan",
                    expired: "Maaf, kami tidak bisa memenuhi pesanan anda di waktu yang Anda pilih. Silakan pilih tanggal atau waktu nanti",
                },
                errors: {
                    stripe_generic: "Kesalahan kartu kredit, mencoba lagi atau dengan cara lain",
                    stripe_loading_fail: "Terjadi kesalahan saat memuat formulir pebayaran, silahkan mencoba lagi",
                    something_went_wrong: "Terjadi kesalahan",
                    paypal_generic: "Terjadi kesalahan dengan PayPal, mencoba lagi atau pilih cara pembayaran yang lain",
                    payment_fail: "Pembayaran gagal, silahkan mencoba lagi atau pilih cara pembayaran yang lain",
                    payment_cancelled: "Pembayaran dibatalkan, silahkan mencoba lagi atau pilih cara pembayaran yang lain",
                    payment_error: "Terjadi kesalahan saat memproses pembayaran online, mencoba lagi atau pilih cara pembayaran yang lain",
                    payment_declined: "Cara pembayaran Anda ditolak",
                    card_declined: "Kartu Anda ditolak dan pembayaran tidak dapat diproses",
                    promo_max_uses_exceeded: "Kode promo ini telah mencapai batas penggunaannya dan tidak lagi tersedia.",
                    store_closed: "Toko tutup dan tidak lagi menerima pesanan",
                    accept_terms: "Silahkan, terima Syarat & Ketentuan",
                    required_payment: "Silahkan pilih cara pembayaran",
                    required_phone: "Silahkan masukkan nomor telepon Anda",
                    required_email: "Silahkan masukkan email Anda",
                    required_name: "Silahkan masukkan nama Anda",
                    invalid_email: "Silakan masukkan alamat email yang valid",
                    invalid_phone: "Silakan masukkan alamat nomor telepon yang valid",
                    invalid_cc_number: "Nomor kartu kredit Anda salah",
                    retry_cc_number: "Terjadi kesalahan. Masukan kembali nomor kartu kredit Anda dan coba lagi",
                    closed: "Toko sedang tutup dan sedang tidak menerima pesanan",
                    promo_login_required: "Anda harus masuk untuk menggunakan promo ini",
                    promo_used: "Anda sudah menggunakan promo ini",
                },
                button: {
                    continue: "Lanjut ke Pembayaran",
                    place_order: "Memesan",
                },
            },
            customer: {
                age_v: {
                    title: "Verifikasi Umur",
                    required_for_items: "Diperlukan untuk memesan barang tertentu",
                    min_age: "Umur Minimum: {{age}} tahun",
                    est_time: "Perkiraan waktu verifikasi: {{time}} jam",
                    upload_description: "Unggah ID Anda di bawah untuk verifikasi. Anda akan diberi tahu melalui email setelah diverifikasi. Unggah hingga 2 gambar dengan ukuran maksimum masing-masing 2 MB",
                    pending_description_1: "Terima kasih telah mengirimkan dokumen Anda. Anda akan diberitahu melalui email pada saat Anda disetujui",
                    pending_description_2: "Segarkan halaman untuk memperbarui status verifikasi Anda. Perkiraan waktu verifikasi adalah {{time}} jam",
                    approved_description: "Akun Anda telah diverifikasi dan Anda dapat memesan dari menu yang dibatasi",
                    rejected_description: "ID Anda telah ditolak. Jika Anda ingin mencoba lagi, unggah ulang ID Anda",
                    upload: "Unggah",
                    reupload: "Unggah Kembali Dokumen",
                    go_back: "Kembali",
                    view_document: "Melihat Dokumen {{number}}",
                    status: {
                        unverified: "Belum di verifikasi",
                        pending: "Menunggu untuk disetujui",
                        approved: "Verifikasi Berhasil",
                        rejected: "Ditolak",
                    },
                },
                headings: {
                    sessions: "Sesi",
                    orders: "Pesanan",
                    spend: "Dibelanjakan",
                    order_history: "Riwayat Pesanan",
                    loyalty_points: "Mata kesetiaan",
                },
            },
            custom_payment: {
                title: "{{name}} Form Pembayaran",
                description: "Anda telah sampai di formulir pembayaran online kami. Harap melengkapi di bawah ini untuk melakukan pembayaran. Jika nilai total belanja tidak dimasukkan, data Anda  otomatis akan tetap ada di sistem kami tanpa ada dikenakan biaya apapun.",
                disabled: "Halaman pembayaran online ini belum dikonfigurasi dengan benar. Harap menghubungi pemilik situs untuk mengatasi masalah tersebut.",
                success: "Pembayaran Anda berhasil diproses dan detail Anda telah disimpan. Terima Kasih",
                back: "Pergi ke Halaman Depan",
                fields: {
                    name: "Nama Lengkap",
                    email: "Alamat E-mail",
                    reference: "Referensi Pembayaran.",
                    amount: "Jumlah ($)",
                    name_on_card: "Nama yang tertera pada kartu",
                    submit: "Kirimkan Pembayaran",
                },
                warning: {
                    currency: "Catatan: Jumlah pembayaran dalam {{actual}}, bukan {{default}}",
                },
                errors: {
                    generic: "Terjadi kesalahan, coba lagi atau hubungi kami",
                    stripe_generic: "Kesalahan kartu kredit, segarkan halaman dan coba lagi",
                    payment_fail: "Pembayaran gagal, silahkan mencoba lagi atau pilih cara pembayaran yang lain",
                    payment_cancelled: "Pembayaran dibatalkan, silahkan mencoba lagi atau pilih cara pembayaran yang lain",
                    payment_error: "Kesalahan memproses pembayaran, mencoba lagi atau pilih cara pembayaran yang lain",
                    payment_declined: "Cara pembayaran Anda ditolak",
                    card_declined: "Kartu Anda ditolak dan pembayaran tidak dapat diproses",
                    promo_max_uses_exceeded: "Kode promo ini telah mencapai batas penggunaannya dan tidak lagi tersedia.",
                },
            },
            dish: {
                add: "Masukkan ke Keranjang",
                edit: "Perbarui Item",
                notes: "Instruksi Khusus...",
                ingredients: {
                    title: "Bahan",
                    uncheck_remove: "Membatalkan pilihan untuk dihapus",
                },
                ingredients_title: "Bahan",
                combo: {
                    choose_dish: "Pilih Hidangan",
                },
                option_sets: {
                    conditions: {
                        select_one: "Pilih satu (Yang Diharuskan)",
                        select_one_optional: "Pilih satu (Boleh Memilih)",
                        select_between: "Pilih di antara {{min}} - {{max}} (Yang Diharuskan)",
                        select_at_least: "Pilih setidaknya {{qty}} (Yang Diharuskan)",
                        select_up_to: "Pilih hingga {{qty}} (Boleh Memilih)",
                        select_multiple: "Memilih ganda (Boleh Memilih)",
                        free_amount: "{{qty}} Pertama Gratis / {{selected}} yang dipilih",
                    },
                },
                error: "Harap perbaiki opsi yang ditandai dengan warna merah",
                added_to_cart: "Item Sudah Ditambahkan Ke Dalam Keranjang",
            },
            map: {
                zone_fee: "Biaya pengiriman",
                view_in_google: "Lihat Di Google Maps",
            },
            portal_go_back: {
                title: "Kembali ke pencarian restaurant?",
                description: "Semua barang di keranjang anda akan hilang",
                cancel: "Batal",
                proceed: "Kembali",
            },
            order: {
                config: {
                    services: {
                        title: "Pilih Layanan",
                        table_booking: "Memesan Meja",
                    },
                    address_custom: {
                        input_placeholder: "Masukkan alamat Anda",
                    },
                    address: {
                        input_placeholder: "Temukan alamat pengiriman anda",
                        extras_placeholder: "Lengkapi alamat pengiriman anda, contoh: Blok, Lantai, dll",
                        search_placeholder: "Cari alamat anda",
                        not_found: "Alamat pengiriman tidak ditemukan atau valid, coba lagi",
                        not_delivering: "Kami saat ini tidak mengirim ke alamat ini",
                        not_in_range: "Alamat anda tidak berada dalam jangkauan lokasi toko kami",
                        not_in_zone: "Alamat Anda tidak berada dalam zona pengiriman aktif",
                    },
                    datetime: {
                        title: "Kapan Anda Ingin Pesanan Anda?",
                        due_now: "Sekarang",
                        due_later: "Nanti",
                        service_not_available: "Maaf, saat ini kami tidak bisa menerima pesanan untuk {{service}}",
                        currently_closed: "{{service}} saat ini tutup tapi anda dapat memesan untuk nanti",
                        due_unavailable: "Tidak Tersedia",
                        due_closed: "Tutup",
                        select_date: "Memilih Tanggal",
                        select_time: "Memilih Waktu",
                        select_order_date: "Pilih tanggal pemesanan anda",
                        select_order_time: "Pilih waktu pemesanan anda",
                        select_booking_date: "Pilih tanggal reservasi anda",
                        select_booking_time: "Pilih waktu reservasi anda",
                        no_times_available: "Tidak ada waktu yang tersedia untuk dipilih",
                        date_today: "(Har ini)",
                        date_closed: "(Tutup)",
                        date_bookings_paused: "(Reservasi dijeda)",
                        time_slot_closed: "Tutup",
                    },
                    number_of_people: {
                        placeholder: "Jumlah Orang",
                    },
                    table: {
                        select: "Pilih Meja",
                        select_popup_title: "Pilih Meja Anda",
                        password: "Kata Sandi Meja",
                        password_warning: "Masukkan kata sandi meja Anda untuk melanjutkan",
                    },
                    warning: {
                        closed: "Maaf, kami sedang tutup / tidak bisa menerima pesanan apa pun",
                        not_available: "Maaf, saat ini kami tidak bisa menerima pesanan apa pun",
                    },
                    start_button: "Mulai Pesanan",
                },
                history: {
                    invalid: "Tidak memenuhi syarat untuk dipesan ulang karena beberapa item yang dipesan telah diubah atau tidak lagi tersedia",
                },
                reorder: {
                    title: "Pemesanan ulang secepatnya",
                    description: "Pesan barang dengan mudah dari pesanan anda sebelumnya",
                },
            },
            receipt: {
                errors: {
                    not_found: "Pesanan tidak ditemukan, segarkan halaman dan coba lagi",
                    booking_not_found: "Reservasi tidak ada. Mungkin telah dihapus",
                    generic: "Terjadi kesalahan, segarkan halaman atau hubungi kami",
                },
                connection: {
                    connected: "Pembaruan untuk waktu yang sesungguhnya",
                    connecting: "Pembaruan waktu yang sesungguhnya tersambung",
                    disconnected: "Pembaruan waktu yang sesungguhnya terputus",
                },
            },
            warnings: {
                logout: {
                    pretitle: "Peringatan",
                    title: "Keluar",
                    body: "Keluar akan menghapus semua item yang telah ditambahkan ke keranjang Anda",
                    cancel: "Batal",
                    proceed: "Memproses",
                },
                order_restart: {
                    warning: "Peringatan",
                    title: "Ubah perincian pesanan",
                    body: "Mengubah detail pesanan Anda akan menghapus item di keranjang Anda karena hidangan tertentu mungkin tidak tersedia",
                    cancel: "Batal",
                    proceed: "Memproses",
                },
                order_expired: {
                    subtitle: "Penting",
                    title: "Pesanan diubah menjadi segera",
                    description: "Waktu yang dipilih untuk pesanan anda sekarang tidak jauh. Dengan demikian pesanan Anda telah diubah menjadi segera / secepatnya",
                    button: "Ok",
                },
                order_expiring: {
                    subtitle: "Penting",
                    title: "Batas waktu pemesanan segera habis",
                    description: "Pesanan Anda harus dilakukan sebelum {{time, timeFromTimestamp}} jika tidak maka tidak berlaku lagi",
                    button: "Ok",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "Tamu",
                login: "Masuk",
                login_signup: "Masuk / Sign Up",
                logout: "Keluar",
            },
            menus: {
                info: {
                    no_menus: "Saat ini tidak ada menu yang tersedia",
                    restrictions: "Pembatasan menu",
                    not_available: "Menu saat ini tidak tersedia",
                    unavailable: {
                        times: "Menu tidak tersedia, persyaratan pesanan Anda tidak sesuai di bawah",
                        services: "Menu tidak tersedia, persyaratan pesanan Anda tidak sesuai di bawah",
                        hours: "Menu tidak tersedia, waktu pesanan Anda tidak tersedia di jam menu yang tersedia",
                        pre_order: "Menu tidak tersedia, pesanan Anda tidak sesuai dengan persyaratan pra-order",
                        age: "Menu tidak tersedia, Anda harus masuk dengan akun yang sudah terverifikasi usia untuk memesan dari menu ini",
                    },
                    services: {
                        title: "Persyaratan pemesanan",
                        pickup: "Diambil",
                        delivery: "Dikirim",
                        dine_in: "Makan di tempat",
                    },
                    times: {
                        now: "Tidak ada pre-order",
                        later: "Khusus untuk pre-order",
                    },
                    hours: {
                        title: "Jam yang tersedia",
                    },
                    preorder: {
                        title: "Persyaratan untuk pre-order",
                        days_in_advance: "Harus memesan {{days}} hari sebelumnya",
                        cutoff_time: "Batas waktu untuk hari terakhir {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Persyaratan usia",
                        approved: "Akun Anda telah diverifikasi dan Anda dapat memesan dari menu ini",
                        rejected: "Memerlukan verifikasi usia untuk memesan. Buat akun dan unggah ID Anda",
                    },
                },
            },
            info: {
                location: {
                    title: "Lokasi",
                    view_map: "Lihat Peta",
                    phone: "Telepon",
                },
                hours: {
                    title: "Jam Buka",
                    title_special: "Jam Buka Khusus",
                },
                services: {
                    title: "Layanan",
                    notes: "Catatan",
                    delivery: {
                        ranges: "Rentang Pengiriman",
                        zones: "Zona Pengiriman",
                        view_zones: "Lihat Zona di Peta",
                        fee: "Biaya pengiriman",
                        fee_short: 'Biaya',
                        fee_varies: "Bervariasi, tampilkan di keranjang belanja",
                        min_order: "Pesanan Minimum",
                        min_order_short: 'Min. pesanan',
                        no_min_order: "Tidak Ada Pesanan Minimum",
                        free_amount: "Ambang Batas Gratis Pengiriman",
                    },
                },
            },
            contact: {
                title: "Hubungi Kami",
                name: "Nama",
                email: "E-mail",
                phone: "Nomor Telepon",
                message: "Masukkan pesan anda...",
                send: "Kirimkan pesan",
                success: "Pesan anda berhasil dikirim",
                error: "Terjadi kesalahan. Silahkan mencoba lagi atau nanti",
            },
            footer: {
                powered_by: "Powered By",
                terms_and_conditions: "Syarat & Ketentuan",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Kwitansi Reservasi',
            details: {
                datetime: 'Reservasi Untuk',
                number_of_people: 'Jumlah Orang',
                placed: 'Tempat',
                updated: 'Terakhir diperbarui',
                notes: 'Catatan',
                name: 'Nama',
                email: 'E-Mail',
                phone: 'Telepon',
                store_address: 'Alamat Toko',
            },
            status_update: {
                title: 'Reservasi {{number}} diperbarui',
                body: 'Status pemesanan Anda telah diperbarui menjadi {{status}}',
            },
            email_status_update_customer: {
                subject: 'Reservasi #{{number}} – {{subjectLabel}}',
                body: 'Reservasi Anda #{{number}} di {{store}} sekarang {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Pesanan #{{number}} – {{subjectLabel}}',
        header: 'Waktu siap diperbarui',
        title: 'Waktu siap diperbarui',
        order_number: 'Jumlah order: {{number}}',
        description: 'Pesanan Anda akan siap pada {{time}}.',
        order_time_updated_to: 'Waktu pesanan Anda telah diperbarui.',
        powered_by: 'Dipersembahkan oleh {{name}}',
        button_text: 'Lacak Pesanan',
        subject_label: 'Waktu siap diperbarui',
        subject_label_delivery: 'Waktu pengiriman diperbarui',
        body_ready: 'Pesanan Anda akan siap pada {{time}}.',
        body_delivery: 'Pesanan Anda akan diantar pada {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Perkiraan waktu siap',
            est_driver_pickup_time: 'Perkiraan waktu pengambilan',
            est_delivery_time: 'Perkiraan waktu pengiriman',
            tab_details: 'Perincian',
            tab_dishes: 'Hidangan',
            details: {
                status: 'Status',
                placed: 'Tempat',
                due: 'Jatuh tempo',
                due_asap: 'Sekarang / Secepatnya',
                last_updated: 'Terakhir diperbarui',
                total: 'Total',
                type: 'Tipe',
                table: 'Meja',
                number_of_people: 'Jumlah orang',
                payment_method: 'Cara Pembayaran',
                payment_status: 'Status Pembayaran',
                payment_currency: 'Mata Uang Pembayaran',
                notes: 'Catatan',
                name: 'Nama',
                email: 'E-Mail',
                phone: 'Telepon',
                distance: 'Jarak',
                driving_time: 'Waktu mengemudi',
                delivery_zone: 'Zona',
                delivery_address: 'Alamat Pengiriman',
                delivery_tracking: 'Pelacakan pengiriman',
                delivery_tracking_link: 'Tautan pelacakan waktu nyata',
                tookan_status: 'Tookan Status',
                tookan_status_failed_book: 'Gagal memesan untuk pengiriman',
                tookan_status_failed_update: 'Gagal untuk pembaruan pesanan',
                tookan_status_success: 'Dipesan untuk pengiriman',
                store_address: 'Alamat Toko',
            },
            dishes: {
                headings: {
                    quantity: 'Jumlah',
                    item: 'Barang',
                    price: 'Harga',
                },
                notes: 'Catatan',
                remove_ingredients: 'Hapus Bahan',
            },
            status_update: {
                title: 'Pesanan {{number}} diperbarui',
                body: 'Status pesanan Anda telah diperbarui menjadi {{status}}',
            },
            wait_time_update: {
                title: 'Pesanan {{number}} diperbarui',
                body: 'Batas waktu pesanan Anda telah diperbarui',
            },
            delivery_update: {
                title: 'Pesanan {{number}} diperbarui',
                body: 'Pesanan Anda telah dipesan untuk pengiriman. Lihat tautan pelacakan waktu nyata',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "Tanda terima pesanan",
                track_delivery_button_text: "Lacak pengiriman",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "Tanda terima pesanan",
                track_delivery_button_text: "Lacak pengiriman",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) dalam harga",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "Biaya pengiriman",
            promo: "Diskon: {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "Diskon: {{name}} ({{percent}}%)",
            promo_fixed: "Diskon: {{name}}",
            promo_none: "Diskon: {{name}}",
            cart: "Keranjang",
            tip: "Tip Persenan",
            total: "Total",
        },
        status: {
            unconfirmed: "Belum dikonfirmasi",
            awaiting_payment: "Menunggu Pembayaran",
            confirmed: "Dikonfirmasi",
            ready: "Siap",
            on_route: "Di jalan",
            complete: "Komplit",
            cancelled: "Batal",
            seated: "Duduk",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "Tidak Tersedia",
                },
            },
            dish: {
                no_stock: "Habis",
                not_available: "Tidak Tersedia",
            },
        },
    },
};
//# sourceMappingURL=id.js.map